import "./FindAddUser.html";
import "./FindUserResultTemplate.html";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import FindAddUserComponentController from "./FindAddUserComponentController";

export class FindAddUserComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            allowEmpty: "<",
            canAddUser: "<",
            clearAfterAdd: "<",
            hideTitle: "<",
            initialValue: "<",
            newUser: "&?",
            partnerId: "<",
            removeFromResult: "<",
            selectUser: "&?",
            title: "<",
            withSelectPrompt: "<",
            disabled: "<",
        };
        this.controller = FindAddUserComponentController;
        this.templateUrl = "/App/Components/Forms/FindAddUser/FindAddUser.html";
    }
}

module("mmManagePortal").component("mmFindAddUser", new FindAddUserComponent());
